import type { ActivityModule } from '../core/activity';
import { learnDigits } from './learn_digits';
import { learnQuantities } from './learn_quantities';
import { learnAdditions } from './learn_additions';
import { learnSubtractions } from './learn_subtractions';
import { tensComplementFind } from './tens_complement_find';
import { tensComplementUse } from './tens_complement_use';
import { tensComplementSwap } from './tens_complement_swap';
import { tensComplementCalculate } from './tens_complement_calculate';
import { adjacentNumbers } from './adjacent_numbers';
import { orderingNumbers } from './ordering_numbers';
import { orderingAlphabets } from './ordering_alphabets';
import { orderingSentences } from './ordering_sentences';
import { numbersOddEven } from './numbers-odd-even';
import { comparator } from './comparator';
import { magicHatPlus } from './magic-hat-plus';
import { magicHatMinus } from './magic-hat-minus';
import { algebraPlus } from './algebra_plus';
import { algebraMinus } from './algebra_minus';
import { memoryMathAdd } from './memory-math-add';
import { memoryMathMinus } from './memory-math-minus';
import { memoryMathMult } from './memory-math-mult';
import { memoryMathDiv } from './memory-math-div';
import { algebraBy } from './algebra_by';
import { algebraDiv } from './algebra_div';
import { verticalAddition } from './vertical_addition';
import { verticalSubtraction } from './vertical_subtraction';
import { verticalSubtractionCompensation } from './vertical_subtraction_compensation';
import { money } from './money';
import { moneyBack } from './money_back';
import { moneyCents } from './money_cents';
import { moneyBackCents } from './money_back_cents';
import { graduatedLineUse } from './graduated_line_use';
import { graduatedLineRead } from './graduated_line_read';
import { fractionsFind } from './fractions_find';
import { fractionsCreate } from './fractions_create';
import { scalesboard } from './scalesboard';
import { guess24 } from './guess24';
import { guesscount } from './guesscount';
import { calcudoku } from './calcudoku';
import { gnumchEquality } from './gnumch-equality';
import { gnumchFactors } from './gnumch-factors';
import { gnumchMultiples } from './gnumch-multiples';
import { gnumchPrimes } from './gnumch-primes';
import { clockgame } from './clockgame';
import { share } from './share';
import { smallNumbers2 } from './smallnumbers2';
import { smallNumbers } from './smallnumbers';
import { numberSequence } from './number_sequence';
import { calendar } from './calendar';
import { guessNumber } from './guessnumber';
import { enumerate } from './enumerate';
import { drawNumbers } from './drawnumbers';
import { reverseCount } from './reversecount';
import { learnDecimals } from './learn_decimals';
import { learnDecimalsAdditions } from './learn_decimals_additions';
import { learnDecimalsSubtractions } from './learn_decimals_subtractions';
import { target } from './target';
import { planegame } from './planegame';
import { romanNumerals } from './roman_numerals';

// Ordem pedagogica: do mais simples (pre-escolar) ao mais avancado.
export const activities: ActivityModule[] = [
  learnDigits,
  learnQuantities,
  learnAdditions,
  learnSubtractions,
  adjacentNumbers,
  orderingNumbers,
  orderingAlphabets,
  orderingSentences,
  numbersOddEven,
  comparator,
  magicHatPlus,
  magicHatMinus,
  algebraPlus,
  algebraMinus,
  tensComplementFind,
  tensComplementUse,
  tensComplementSwap,
  tensComplementCalculate,
  memoryMathAdd,
  memoryMathMinus,
  algebraBy,
  memoryMathMult,
  algebraDiv,
  memoryMathDiv,
  verticalAddition,
  verticalSubtraction,
  verticalSubtractionCompensation,
  money,
  moneyBack,
  moneyCents,
  moneyBackCents,
  graduatedLineRead,
  graduatedLineUse,
  fractionsFind,
  fractionsCreate,
  scalesboard,
  drawNumbers,
  reverseCount,
  learnDecimals,
  learnDecimalsAdditions,
  learnDecimalsSubtractions,
  target,
  enumerate,
  numberSequence,
  smallNumbers,
  smallNumbers2,
  planegame,
  guessNumber,
  clockgame,
  calendar,
  share,
  guess24,
  guesscount,
  calcudoku,
  gnumchEquality,
  gnumchFactors,
  gnumchMultiples,
  gnumchPrimes,
  romanNumerals,
];
